import { Task } from 'src/models/task';

import { Callback } from 'src/util/query/models/Callback';

export class TaskCallback extends Callback<Task> {
	public constructor(private readonly setTask: (task: Task | null) => void) {
		super();
	}

	failureCallbackFunction = (): void => {
		// Handle failure silently
	};

	successCallbackFunction = (successResponse: Task): void => {
		this.setTask(successResponse);
	};
}
